function Comp27() {
    document.addEventListener("DOMContentLoaded", () => {
        const container = document.querySelector(".element-container");
        const elements = document.querySelectorAll(".element");
        const phoneElement = document.getElementById("item-phone");
        const selectedTextSpan = document.getElementById("selected-text");

        let isLocked = false;
        let activeElement = null;

        const PHONE_NO_ZOOM_TRANSFORM = `translate(-50%, -50%) rotateZ(0deg) scale(1) translateZ(50px)`;
        const ANIMATION_DURATION_MS = 500;

        // Başlangıç transform’larını oku (ileride gerekebilir)
        const initialTransforms = new Map();
        elements.forEach((el) => {
            const style = window.getComputedStyle(el);
            initialTransforms.set(el.id, style.transform);
        });

        // === Ana Click Olayı ===
        container.addEventListener("click", (e) => {
            // 1. Öncelikli olarak tıklanan yerden bir ikon (.element.icon) yakalamaya çalış
            // Bu, telefonun büyük tıklama alanının ikonu ezmesini engeller.
            let clickedElement = e.target.closest(".element.icon");

            // 2. Eğer bir ikon yakalayamadıysak, herhangi bir .element yakalamayı dene (bu muhtemelen telefonu yakalar)
            if (!clickedElement) {
                clickedElement = e.target.closest(".element");
            }

            // 3. ANKETROL: Zaten bir öğe aktif mi? Aktifse ve tıklanan öğe aktif öğe değilse, diğer tüm tıklamaları yok say.
            // Ancak, tıklanan öğe aktif öğenin KENDİSİYSE, resetlemeye izin ver.
            if (activeElement && clickedElement !== activeElement) {
                return;
            }

            // 4. Animasyon sürerken başka tıklamayı engelle (Tıklanan öğe aktif öğenin kendisi olsa bile)
            if (isLocked) return;

            // 5. Aktif olan öğeye tekrar tıklama → reset
            if (clickedElement && activeElement === clickedElement) {
                resetAllElements();
                return;
            }

            // 6. Boş alana tıklama → reset
            if (!clickedElement) {
                if (activeElement) resetAllElements();
                return;
            }

            // 7. Yeni öğeyi aktif et
            setActiveElement(clickedElement);
        });

        function setActiveElement(el) {
            isLocked = true;
            activeElement = el;

            // Zoomlu bir öğe var, container'a sınıfı ekle
            container.classList.add("has-active-element");

            const isPhone = el === phoneElement;

            const dataText = el.getAttribute("data-text");
            const textContainer = selectedTextSpan
                ? selectedTextSpan.parentElement
                : null;

            if (textContainer && dataText) {
                selectedTextSpan.textContent = dataText;
                textContainer.classList.add("is-visible");
            }

            // Tüm öğeleri pasifleştir
            elements.forEach((other) => {
                if (other !== el) {
                    // İKONLAR: Pasif sınıfı
                    if (other.classList.contains("icon")) {
                        other.classList.add("passive");
                    }

                    // TELEFON: Eğer tıklanan ikon ise, telefonu da pasifleştir
                    if (!isPhone && other === phoneElement) {
                        other.classList.add("is-passive");
                    }
                }
            });

            // Tıklanan öğeyi aktif yap
            el.classList.add("active");

            if (isPhone) {
                el.classList.add("is-active-no-zoom");
                el.style.transform = PHONE_NO_ZOOM_TRANSFORM;
            } else {
                el.classList.add("active-icon-zoom");
            }

            // Animasyon süresi kadar bekle, sonra kilidi kaldır
            setTimeout(() => (isLocked = false), ANIMATION_DURATION_MS);
        }

        function resetVisuals() {
            // Zoomlu öğe kalmadı, container'dan sınıfı kaldır
            container.classList.remove("has-active-element");

            if (selectedTextSpan) {
                const textContainer = selectedTextSpan.parentElement;
                if (textContainer) {
                    textContainer.classList.remove("is-visible");
                    // Geçişin yarısında metni temizle (görsel olarak daha akıcı olabilir)
                    setTimeout(() => {
                        selectedTextSpan.textContent = "";
                    }, 250);
                }
            }

            elements.forEach((el) => {
                el.classList.remove(
                    "active",
                    "active-icon-zoom",
                    "is-active-no-zoom",
                    "passive"
                );
                if (el === phoneElement) el.classList.remove("is-passive");

                // JS’te atanmış transformları sıfırla (sadece telefonun aktif transformu)
                el.style.transform = "";
            });
        }

        function resetAllElements() {
            isLocked = true;
            resetVisuals();

            // Her şey sıfırlandıktan sonra aktif elemanı boşalt
            setTimeout(() => {
                activeElement = null;
                isLocked = false;
            }, ANIMATION_DURATION_MS);
        }
    });
}
Comp27();
